import { render } from "./SimplifySection.vue?vue&type=template&id=29cf931a&scoped=true"
const script = {}

import "./SimplifySection.vue?vue&type=style&index=0&id=29cf931a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29cf931a"]])

export default __exports__